/**
 * Storezone — Auth Layout
 *
 * Centered card layout for login and public auth pages.
 * Applies the 'storezone' theme.
 */

import { type ReactNode } from 'react'
import './AuthLayout.css'

interface AuthLayoutProps {
  children: ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="sz-auth-layout">
      <div className="sz-auth-layout__inner">{children}</div>
    </div>
  )
}
